export const COPY_TO_CLIPBOARD = 'onboarding/setupEmail/COPY_TO_CLIPBOARD'
export const CLEAR_COPY_TO_CLIPBOARD_RESPONSE =
  'onboarding/setupEmail/CLEAR_COPY_TO_CLIPBOARD_RESPONSE'
